const formatDatoId = id => {
  return id?.match(/DatoCms(?:.*?)-(.*)-[a-z]{1,3}$/)?.[1] || id;
};

export default formatDatoId;
